import { Slide, toast, ToastOptions } from 'react-toastify'
import Toast from '@/components/ui/Toast'
import React from 'react'
import { ReactComponent as SuccessIcon } from '@/assets/icons/checkmark-fill.svg'
import { ReactComponent as ErrorIcon } from '@/assets/icons/warning.svg'

export const toastConfig: ToastOptions = {
  position: 'bottom-right',
  transition: Slide,
  autoClose: 16000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: false,
}

export const toastError = (title: string, caption?: string, options: Partial<ToastOptions> = {}) => {
  toast.error(<Toast title={title} caption={caption} />, {
    icon: <ErrorIcon />,
    ...options,
  })
}

export const toastSuccess = (title: string, caption?: string, options: Partial<ToastOptions> = {}) => {
  toast.success(<Toast title={title} caption={caption} />, {
    icon: <SuccessIcon />,
    ...options,
  })
}

export const dismissAllToasts = () => toast.dismiss()
